import _ from 'lodash';
import classNames from 'classnames';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import IssueActionsBar from '../issues/issueActionsBar';
import IssueResolveAsRebooked from '../issues/issueResolveAsRebooked';
import IssueResolveAsReprotected from '../issues/issueResolveAsReprotected';
import IssueResolveAsNoChangesMade from '../issues/issueResolveAsNoChangesMade';
import IssueResolveAsExpired from '../issues/issueResolveAsExpired';
import { IssueService, SharedIssue } from '../../js/issues/issueService';
import { collectGarbage } from '../../js/configTdm';
import { successfulAction } from '../../js/issues/IssueActionsCtrls';
import IssueComment from '../issues/issueComment';
import IssueAssign from '../issues/issueAssign';
import IssueDetails from '../issues/issueDetails';
import IssueDefer from '../issues/issueDefer';
import { modalContentStyle } from '../../js/components/modal/Modal';
import { Modal } from '@flightstats/airframe-react';
import { TripIssueProps } from '../../js/headersegment/interfaces';
import FullPageLoadingSpinner from '../../js/pages/components/fullPageLoadingSpinner';

const IssueActionContext = React.createContext<any>(null);

export const useIssueAction = () => {
  return useContext(IssueActionContext);
};

const TripIssue: React.FC<TripIssueProps> = ({
  trip,
  awayContactPointsMap,
  parentIssue,
  callback
}) => {
  const [issue, setIssue] = useState<any>(parentIssue);
  const [issueSelected, setIssueSelected] = useState(false);
  const [issueActionModal, setIssueActionModal] = useState(false);
  const [usernames, setUsernames] = useState<string[]>([]);
  const [awayContactPoints, setAwayContactPoints] = useState<any[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [template, setTemplate] = useState<React.ReactNode | null>(null);
  const [size, setSize] = useState<string | null>(null);
  const [tabOpen, setTabOpen] = useState(true);
  const [rebookedTabOpen, setRebookedTabOpen] = useState(false);
  const issueActionPanelRef = useRef<HTMLDivElement | null>(null);
  const [rebookedTabActive, setRebookedTabActive] = useState('');
  const [reprotectedTabOpen, setReprotectedTabOpen] = useState(false);
  const [reprotectedTabActive, setReprotectedTabActive] = useState('');
  const [noChangesMadeTabOpen, setNoChangesMadeTabOpen] = useState(false);
  const [noChangesMadeTabActive, setNoChangesMadeTabActive] = useState('');
  const [expiredTabOpen, setExpiredTabOpen] = useState(false);
  const [expiredTabActive, setExpiredTabActive] = useState('');
  const [
    connectionIssueAccordionOpen,
    setConnectionIssueAccordionOpen,
  ] = useState(false);
  const connectionIssuepanelRef = useRef<HTMLDivElement>(null);
  const [issueHover, setIssueHover] = useState(false);
  const [issueCommentsAccordionOpen, setIssueCommentsAccordionOpen] = useState(
    false,
  );
  const issueCommentsPanelRef = useRef<HTMLDivElement>(null);
  const [commentsHover, setCommentsHover] = useState(false);
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith('#issue-')) {
      setConnectionIssueAccordionOpen(
        hash.replace('#issue-', '') === parentIssue.id,
      );
      setIssueSelected(hash.replace('#issue-', '') === parentIssue.id);
    }
    init(issue);
    return () => {
      setIssue(null);
      setUsernames([]);
      if (awayContactPoints && _.isArray(awayContactPoints)) {
        setAwayContactPoints([]);
      }
      collectGarbage();
    };
  }, []);

  useEffect(() => {
    if (connectionIssuepanelRef.current) {
      if (connectionIssueAccordionOpen) {
        connectionIssuepanelRef.current.style.maxHeight = `${connectionIssuepanelRef.current.scrollHeight}px`;
        callback?.();
      } else {
        connectionIssuepanelRef.current.style.maxHeight = '0';
      }
    }
  }, [connectionIssueAccordionOpen, issue]);

  useEffect(() => {
    if (issueCommentsPanelRef.current && connectionIssuepanelRef.current) {
      if (issueCommentsAccordionOpen) {
        issueCommentsPanelRef.current.style.maxHeight = `${issueCommentsPanelRef.current.scrollHeight}px`;
        connectionIssuepanelRef.current.style.maxHeight = `${connectionIssuepanelRef.current.scrollHeight + issueCommentsPanelRef.current.scrollHeight}px`;
        callback?.();
      } else {
        issueCommentsPanelRef.current.style.maxHeight = '0';
        connectionIssuepanelRef.current.style.maxHeight = connectionIssueAccordionOpen ? `${connectionIssuepanelRef.current.scrollHeight}px` : '0';
      }
    }
  }, [issueCommentsAccordionOpen]);

  useEffect(() => {
    if (issueActionPanelRef.current) {
      if ((rebookedTabOpen || reprotectedTabOpen || noChangesMadeTabOpen || expiredTabOpen) && connectionIssuepanelRef.current) {
        issueActionPanelRef.current.style.maxHeight = `${issueActionPanelRef.current.scrollHeight}px`;
        connectionIssuepanelRef.current.style.maxHeight = `${connectionIssuepanelRef.current.scrollHeight + issueActionPanelRef.current.scrollHeight}px`;
        callback?.();
      } else {
        issueActionPanelRef.current.style.maxHeight = '0';
      }
    }
  }, [rebookedTabOpen, reprotectedTabOpen, noChangesMadeTabOpen, expiredTabOpen]);


  const sharedHotKeys = (event: KeyboardEvent) => {
    switch (event.key) {
      case 'g':
        hotkey(event, 'assign');
        break;
      case 's':
        hotkey(event, 'assist');
        break;
      case 'c':
        hotkey(event, 'comment');
        break;
      case 'd':
        hotkey(event, 'defer');
        break;
      case 'i':
        hotkey(event, 'details');
        break;
      case 'm':
        hotkey(event, 'message');
        break;
      case 'o':
        hotkey(event, 'reopen');
        break;
      case 'b':
        hotkey(event, 'rebooked');
        break;
      case 'p':
        hotkey(event, 'reprotected');
        break;
      case 'n':
        hotkey(event, 'noChangesMade');
        break;
      case 'x':
        hotkey(event, 'expired');
        break;
      default:
        break;
    }
  };

  const hotkey = (event: KeyboardEvent, data: string) => {
    switch (data) {
      case 'assign':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          modifyIssue(
            null,
            <IssueAssign
              ok={reset}
              cancel={reset}
              issue={issue}
              issueUpdated={updateIssue}
              size={'sm'}
              loadSpinner={(caller: boolean) => setLoading(caller)}
            ></IssueAssign>,
            'sm',
          );
        }
        break;
      case 'assist':
        if (
          issueSelected &&
          !issueActionModal &&
          !isIssueAssisting() &&
          !isIssueClosed()
        ) {
          assistIssue(event);
        }
        break;
      case 'comment':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          modifyIssue(
            null,
            <IssueComment
              ok={reset}
              cancel={reset}
              issue={issue}
              issueUpdated={updateIssue}
            ></IssueComment>,
          );
        }
        break;
      case 'defer':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          modifyIssue(
            null,
            <IssueDefer
              ok={reset}
              cancel={reset}
              issue={issue}
              issueUpdated={updateIssue}
            ></IssueDefer>,
          );
        }
        break;
      case 'details':
        if (issueSelected && !issueActionModal) {
          modifyIssue(
            null,
            <IssueDetails
              cancel={reset}
              issue={issue}
              size={'lg'}
              loadSpinner={(caller: boolean) => setLoading(caller)}
            ></IssueDetails>,
            'lg',
          );
        }
        break;
      case 'message':
        if (
          issueSelected &&
          !issueActionModal &&
          awayContactPointsAvailable()
        ) {
          window.open('mailto:' + awayContactPointsEmails());
        }
        break;
      case 'reopen':
        if (issueSelected && !issueActionModal && !isIssueOpen()) {
          openIssue(event);
        }
        break;
      case 'rebooked':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          tabClicked('rebooked', event);
        }
        break;
      case 'reprotected':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          tabClicked('reprotected', event);
        }
        break;
      case 'noChangesMade':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          tabClicked('noChangesMade', event);
        }
        break;
      case 'expired':
        if (issueSelected && !issueActionModal && !isIssueClosed()) {
          tabClicked('expired', event);
        }
        break;
      default:
        break;
    }
  };

  const updateIssue = useCallback(
    async (data: { issueId: string }, panel?: string) => {
      if (data.issueId === issue.id) {
        try {
          if (panel === 'comments') {
            setIssueCommentsAccordionOpen(false);
          }
          const resp = await IssueService.details(data.issueId);
          if (resp?.status === 200 && resp?.data?.id != null) {
            setIssue({
              ...issue,
              ...SharedIssue.processIssue(
                resp.data,
                false,
                resp.data.usernames,
              ),
            });
          }
        } catch (error) {
          console.error('An error occurred while retrieving the issue:', error);
        }
      }
    },
    [issue],
  );

  const defocus = (data: string) => {
    setIssueSelected(data === 'issue-' + issue.id);
  };

  const isIssueClosed = useCallback(() => issue?.state === 'Closed', [issue]);
  const isIssueAssisting = useCallback(() => issue?.state === 'Assisting', [
    issue,
  ]);
  const isIssueOpen = useCallback(() => issue?.state === 'Open', [issue]);
  const hasComments = useCallback(() => !!issue?.comments?.length, [issue]);
  const awayContactPointsAvailable = useCallback(
    () => awayContactPoints.length > 0,
    [awayContactPoints],
  );
  const awayContactPointsEmails = useCallback(
    () => awayContactPoints.map(c => c.contact).join(),
    [awayContactPoints],
  );

  const assistIssue = useCallback((event: any) => changeIssueState(event, 'ASSISTING'), []);
  const openIssue = useCallback((event: any) => changeIssueState(event, 'OPEN'), []);

  const init = useCallback((issueData: any) => {
    setIssue({
      ...issue,
      ...SharedIssue.processIssue(issueData, false, trip.usernames),
    });
    setIssueActionModal(false);
    setUsernames(trip.usernames);
    setAwayContactPoints(
      _.reduce(
        awayContactPointsMap,
        (result, value) => result.concat(value),
        [],
      ),
    );
  }, []);

  const changeIssueState = useCallback(
    async (event: React.MouseEvent, state?: string) => {
      setModalFocusState();

      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      if (parentIssue?.id && state) {
        try {
          setLoading(true);
          const data = await IssueService.changeState(
            [{ id: parentIssue.id, tripId: parentIssue.tripId }],
            state,
          );
          setLoading(false);
          if (successfulAction(data)) {
            setIssueActionModal(false);
            updateIssue({
              issueId: parentIssue.id,
            });
          } else {
            setIssueActionModal(false);
          }
        } catch (error) {
          setLoading(false);
          console.error('Error changing issue state:', error);
          setIssueActionModal(false);
        }
      }
    },
    [parentIssue, updateIssue],
  );

  const modifyIssue = useCallback(
    (event: any, template: React.ReactNode, size?: string) => {
      setModalFocusState();

      if (event) {
        event.stopPropagation();
        event.cancelBubble = true;
        event.result = false;
      }

      if (template) {
        setIsOpen(true);
        setTemplate(template);
        setSize(size || null);
      }

      return false;
    },
    [],
  );

  const tabClicked = (tab: string, event: any) => {
    event.stopPropagation();
    setRebookedTabOpen(false);
    setRebookedTabActive('');
    setReprotectedTabOpen(false);
    setReprotectedTabActive('');
    setNoChangesMadeTabOpen(false);
    setNoChangesMadeTabActive('');
    setExpiredTabOpen(false);
    setExpiredTabActive('');

    switch (tab) {
      case 'rebooked':
        setRebookedTabOpen(!rebookedTabOpen);
        setRebookedTabActive(!rebookedTabOpen ? 'tab-active' : '');
        break;
      case 'reprotected':
        setReprotectedTabOpen(!reprotectedTabOpen);
        setReprotectedTabActive(!reprotectedTabOpen ? 'tab-active' : '');
        break;
      case 'noChangesMade':
        setNoChangesMadeTabOpen(!noChangesMadeTabOpen);
        setNoChangesMadeTabActive(!noChangesMadeTabOpen ? 'tab-active' : '');
        break;
      case 'expired':
        setExpiredTabOpen(!expiredTabOpen);
        setExpiredTabActive(!expiredTabOpen ? 'tab-active' : '');
        break;
    }
  };

  const setIssueSelectedAct = (value: boolean) => {
    if (!issueActionModal) {
      setIssueSelected(value);
      if (value) {
        document.querySelectorAll('.selected-issue').forEach(el => {
          if (el.id !== `issue-${issue.id}`) {
            el.classList.remove('selected-issue');
            el.classList.add('non-selected-issue');
          }
        });
      }
    } else {
      setIssueActionModal(false);
    }
  };

  const hasNote = () => issue.note !== null;

  const eatEvent = (event: any) => {
    if (event) {
      event.stopPropagation();
      event.cancelBubble = true;
      event.result = false;
    }
  };

  const setModalFocusState = () => {
    setIssueActionModal(true);
    defocus('issue-' + issue.id);
  };

  const reset = () => {
    setIsOpen(false);
    setTemplate(null);
  };

  const openIssueDetails = (event: any, size?: string) =>
    modifyIssue(
      event,
      <IssueDetails
        cancel={reset}
        issue={issue}
        size={size || ''}
        loadSpinner={(caller: boolean) => setLoading(caller)}
      ></IssueDetails>,
      size,
    );

  const openIssueAssign = (event: any, size?: string) =>
    modifyIssue(
      event,
      <IssueAssign
        ok={reset}
        cancel={reset}
        issue={issue}
        issueUpdated={updateIssue}
        size={size || ''}
        loadSpinner={(caller: boolean) => setLoading(caller)}
      ></IssueAssign>,
      size,
    );

  const openIssueComment = (event: any, size?: string) =>
    modifyIssue(
      event,
      <IssueComment
        ok={reset}
        cancel={reset}
        issue={issue}
        issueUpdated={(updateddata: { issueId: string }) => {
          updateIssue(updateddata, 'comments');
        }
        }
        size={size || ''}
      ></IssueComment>,
      size,
    );

  const openIssueDefer = (event: any, size?: string) =>
    modifyIssue(
      event,
      <IssueDefer
        ok={reset}
        cancel={reset}
        issue={issue}
        issueUpdated={updateIssue}
        size={size || ''}
      ></IssueDefer>,
      size,
    );

  return (
    <>
      {loading && <FullPageLoadingSpinner />}
      <IssueActionContext.Provider
        value={{
          issue,
          issueSelected,
          issueActionModal,
          usernames,
          awayContactPoints,
          init,
          isIssueClosed,
          isIssueAssisting,
          isIssueOpen,
          hasComments,
          awayContactPointsAvailable,
          awayContactPointsEmails,
          modifyIssue,
          assistIssue,
          openIssue,
          openIssueComment,
          openIssueDefer,
          eatEvent,
        }}
      >
        <div className="row issue" id={`issue-${issue.id}`}>
          <div
            onFocus={() => setIssueSelectedAct(true)}
            onBlur={() => setIssueSelectedAct(false)}
            tabIndex={1}
          >
            <div
              className={`col-md-12 ${isIssueClosed() ? 'issue-resolved' : ''
                } ${issueSelected ? 'selected-issue' : 'non-selected-issue'}`}
            >
              <div className="hidden-sm hidden-xs">
                <div className="actions-bar">
                  <IssueActionsBar
                    openIssueDetails={openIssueDetails}
                    openIssueAssign={openIssueAssign}
                  ></IssueActionsBar>
                </div>
              </div>
              <div
                data-uib-accordion
                data-close-others="false"
                issue-focus={`issue-${issue.id}`}
                className="col-sm-12 p-0"
              >
                <div
                  className={`panel-group col-sm-12 p-0 ${!isIssueClosed() ? 'm-0' : ''
                    }`}
                >
                  <div
                    className="panel m-0 col-sm-12 p-0"
                  >
                    <div className="panel-heading">
                      <div className="panel-title">
                        <a>
                          <div
                            className="text-align-center"
                            onClick={event => {
                              event.stopPropagation();
                              setConnectionIssueAccordionOpen(
                                !connectionIssueAccordionOpen,
                              );
                            }}
                            onMouseEnter={() => setIssueHover(true)}
                            onMouseLeave={() => setIssueHover(false)}
                          >
                            <i
                              className={`pull-left sprites ${connectionIssueAccordionOpen && issueHover
                                ? 'sprite-arrow-orange-down'
                                : connectionIssueAccordionOpen && !issueHover
                                  ? 'sprite-arrow-choc-down'
                                  : !connectionIssueAccordionOpen && issueHover
                                    ? 'sprite-arrow-orange-right'
                                    : 'sprite-arrow-choc-right'
                                }`}
                            ></i>
                            <span className="hidden-xs">
                              ISSUE - {issue.titleValue}
                            </span>
                            <span className="visible-xs">
                              {issue.titleValue}
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div ref={connectionIssuepanelRef} className={`panel-collapse ${connectionIssueAccordionOpen ? 'in' : ''} `}>
                      <>
                        <div className="col-md-12 content">
                          <div className="row visible-sm visible-xs actions-bar-sm-xs-wrapper">
                            <div className="col-md-12">
                              <div className="hidden-xs actions-bar-sm">
                                <IssueActionsBar
                                  openIssueDetails={openIssueDetails}
                                  openIssueAssign={openIssueAssign}
                                ></IssueActionsBar>
                              </div>
                              <div className="visible-xs actions-bar-xs">
                                <IssueActionsBar
                                  openIssueDetails={openIssueDetails}
                                  openIssueAssign={openIssueAssign}
                                ></IssueActionsBar>
                              </div>
                            </div>
                          </div>
                          {hasNote() && (
                            <div className="row">
                              <div className="col-md-12 note">
                                {issue.noteValue}
                              </div>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
                              DESCRIPTION
                            </div>
                            <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
                              DESCRIPTION
                            </div>
                            <div className="col-md-8 fs-text">
                              <span
                                className={`fs-text-xs ${!isIssueClosed() ? 'highlight-value' : ''
                                  }`}
                              >
                                {issue.descriptionValue}
                              </span>
                            </div>
                            <div className="col-md-1"></div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                TYPE
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                TYPE
                              </div>
                              <div className="col-md-6 fs-text">
                                <span
                                  className={`fs-text-xs ${!isIssueClosed() ? 'highlight-value' : ''
                                    }`}
                                >
                                  {issue.typeValue}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                STATUS
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                STATUS
                              </div>
                              <div className="col-md-6 fs-text">
                                <span
                                  className={`fs-text-xs ${isIssueAssisting() ? 'highlight-value' : ''
                                    }`}
                                >
                                  {issue.stateValue}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                ASSIGNED TO
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                ASSIGNED TO
                              </div>
                              <div className="col-md-6 fs-text">
                                <span className="fs-text-xs">
                                  {issue.assignedToUsernameValue}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                RESOLUTION
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                RESOLUTION
                              </div>
                              <div className="col-md-6 fs-text">
                                <span
                                  className={`fs-text-xs ${isIssueClosed() ? 'highlight-value' : ''
                                    }`}
                                >
                                  {issue.resolutionValue}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                SUB RESOLUTION
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                SUB RESOLUTION
                              </div>
                              <div className="col-md-6 fs-text">
                                <span
                                  className={`fs-text-xs ${isIssueClosed() ? 'highlight-value' : ''
                                    }`}
                                >
                                  {issue.subResolutionValue}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                OPT-IN TRAVELER
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                OPT-IN TRAVELER
                              </div>
                              <div className="col-md-6 fs-text">
                                <span className="fs-text-xs">
                                  {issue.optInTravelerValue}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                TRAVELER CONTACTED
                              </div>
                              <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                TRAVELER CONTACTED
                              </div>
                              <div className="col-md-6 fs-text">
                                <span
                                  className={`fs-text-xs ${isIssueClosed() ? 'highlight-value' : ''
                                    }`}
                                >
                                  {issue.travelerContactedValue}
                                </span>
                              </div>
                            </div>
                          </div>
                          {!isIssueClosed() && (
                            <div className="row">
                              <div className="col-md-6">
                                <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                  CREATED AT
                                </div>
                                <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                  CREATED AT
                                </div>
                                <div className="col-md-6 fs-text">
                                  <span className="fs-text-xs">
                                    {issue.creationDateValue}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="col-md-6 fs-label fs-label-hxs hidden-sm hidden-xs">
                                  RESOLVE BY
                                </div>
                                <div className="col-md-6 fs-label fs-label-xs visible-sm visible-xs">
                                  RESOLVE BY
                                </div>
                                <div className="col-md-6 fs-text">
                                  <span className="highlight-value fs-text-xs">
                                    {issue.resolveByTimeValue}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {hasComments() && (
                          <div className={`col-md-12 comments`}>
                            <div data-uib-accordion data-close-others="false">
                              <div
                                className={`panel-group col-sm-12 p-0 ${!isIssueClosed() ? 'm-0' : ''
                                  }`}
                              >
                                <div
                                  className="panel m-0 col-sm-12 p-0"
                                >
                                  <div className="panel-heading">
                                    <div className="panel-title">
                                      <a>
                                        <div
                                          className="text-align-center"
                                          onClick={event => {
                                            event.stopPropagation();
                                            setIssueCommentsAccordionOpen(
                                              !issueCommentsAccordionOpen,
                                            );
                                          }}
                                          onMouseEnter={() =>
                                            setCommentsHover(true)
                                          }
                                          onMouseLeave={() =>
                                            setCommentsHover(false)
                                          }
                                        >
                                          <i
                                            className={classNames(
                                              'pull-left',
                                              'sprites',
                                              {
                                                'sprite-arrow-orange-down':
                                                  issueCommentsAccordionOpen &&
                                                  commentsHover,
                                                'sprite-arrow-choc-down':
                                                  issueCommentsAccordionOpen &&
                                                  !commentsHover,
                                                'sprite-arrow-orange-right':
                                                  !issueCommentsAccordionOpen &&
                                                  commentsHover,
                                                'sprite-arrow-choc-right':
                                                  !issueCommentsAccordionOpen &&
                                                  !commentsHover,
                                              },
                                            )}
                                          ></i>
                                          ISSUE COMMENTS
                                        </div>
                                      </a>
                                    </div>
                                  </div>

                                  <div ref={issueCommentsPanelRef} className={`issue-collapse ${issueCommentsAccordionOpen ? 'in' : ''} col-md-12 bottom-padding`}>
                                    <table className="table table-condensed comments-table">
                                      <thead>
                                        <tr>
                                          <th>Date/Time</th>
                                          <th>By</th>
                                          <th>Comment</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {issue.comments.map(
                                          (comment: any, index: any) => (
                                            <tr key={index}>
                                              <td className="datetime">
                                                {comment.createTimeFormatted}
                                              </td>
                                              <td className="user">
                                                {comment.byUsername}
                                              </td>
                                              <td className="comment">
                                                <pre>{comment.comment}</pre>
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {!isIssueClosed() && (
                          <div className="col-md-12 action-bar">
                            <div className="row action-bar-row">
                              <div className="col-md-12">
                                <div className="col-md-3">
                                  <div className="btn-wrapper">
                                    <button
                                      className={`btn ${!rebookedTabOpen
                                        ? 'btn-inactive'
                                        : 'btn-active'
                                        }`}
                                      onClick={event =>
                                        tabClicked('rebooked', event)
                                      }
                                    >
                                      REBOOKED
                                    </button>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="btn-wrapper">
                                    <button
                                      className={`btn ${!reprotectedTabOpen
                                        ? 'btn-inactive'
                                        : 'btn-active'
                                        }`}
                                      onClick={event =>
                                        tabClicked('reprotected', event)
                                      }
                                    >
                                      REPROTECTED
                                    </button>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="btn-wrapper">
                                    <button
                                      className={`btn ${!noChangesMadeTabOpen
                                        ? 'btn-inactive'
                                        : 'btn-active'
                                        }`}
                                      onClick={event =>
                                        tabClicked('noChangesMade', event)
                                      }
                                    >
                                      <span className="hidden-md">
                                        NO CHANGES MADE
                                      </span>
                                      <span className="visible-md">
                                        NO CHANGES...
                                      </span>
                                    </button>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="btn-wrapper">
                                    <button
                                      className={`btn ${!expiredTabOpen
                                        ? 'btn-inactive'
                                        : 'btn-active'
                                        }`}
                                      onClick={event =>
                                        tabClicked('expired', event)
                                      }
                                    >
                                      EXPIRED
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-1"></div>
                            </div>
                            <div className="row action-panel" ref={issueActionPanelRef}>
                              {(rebookedTabOpen ||
                                reprotectedTabOpen ||
                                noChangesMadeTabOpen ||
                                expiredTabOpen) && (
                                  <div className="col-md-12 tab-content">
                                    {rebookedTabOpen && (
                                      <div>
                                        <IssueResolveAsRebooked
                                          issueUpdated={updateIssue}
                                          issue={issue}
                                        ></IssueResolveAsRebooked>
                                      </div>
                                    )}
                                    {reprotectedTabOpen && (
                                      <div>
                                        <IssueResolveAsReprotected
                                          issueUpdated={updateIssue}
                                          issue={issue}
                                        ></IssueResolveAsReprotected>
                                      </div>
                                    )}
                                    {noChangesMadeTabOpen && (
                                      <div>
                                        <IssueResolveAsNoChangesMade
                                          issueUpdated={updateIssue}
                                          issue={issue}
                                        ></IssueResolveAsNoChangesMade>
                                      </div>
                                    )}
                                    {expiredTabOpen && (
                                      <div>
                                        <IssueResolveAsExpired
                                          issueUpdated={updateIssue}
                                          issue={issue}
                                        ></IssueResolveAsExpired>
                                      </div>
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                  {!isIssueClosed() && <div className="arrow"></div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </IssueActionContext.Provider>
      <Modal
        isOpen={isOpen}
        contentStyle={modalContentStyle}
        onRequestClose={() => {
          setIssueActionModal(false);
          setIsOpen(false);
          setTemplate(null);
        }}
      >
        {template}
      </Modal>
    </>
  );
};

export default TripIssue;
